import {
  JbTextArea
} from "./chunk.LPZPDKX5.js";
import {
  JbTextField
} from "./chunk.7CIHX5WT.js";
import {
  JbRadio
} from "./chunk.EB7CZPKO.js";
import {
  JbSelect
} from "./chunk.YS6IZRZV.js";
import {
  JbInfoBox
} from "./chunk.2WSRIDIQ.js";
import {
  jb_form_css_default
} from "./chunk.ABTCEKKG.js";
import {
  JbRichtext
} from "./chunk.XW4KQ65Y.js";
import {
  JbCheckbox
} from "./chunk.Q7OIS6Q3.js";
import {
  JbButtonPrimary
} from "./chunk.PA2KQEGQ.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  setLink
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-form/jb-form.ts
var JbForm = class extends Initiable(Spaceable(i)) {
  constructor() {
    super(...arguments);
    this.bordered = false;
    this.displayGrid = true;
  }
  static create(formProperties) {
    return new JbForm().init({
      props: formProperties
    });
  }
  updated(_changedProperties) {
    if (!_changedProperties.has("contentElements")) return;
    this._generateForm();
  }
  async firstUpdated() {
    if (this.trackingSubject) {
      const componentObserver = new IntersectionObserver(
        async (entries, observer) => {
          if (entries[0].isIntersecting) {
            this.dispatchEvent(
              new CustomEvent("jb-tracking", {
                detail: {
                  event: "ce_form",
                  event_version: "v2",
                  component_name: "contact-form",
                  form_component: this,
                  form_step_name: "form open",
                  form_step_nr: "1",
                  form_subject: this.trackingSubject,
                  form_type: "contact"
                },
                bubbles: true,
                composed: true
              })
            );
            observer.disconnect();
          }
        },
        {
          rootMargin: "0px"
        }
      );
      componentObserver.observe(this);
    }
    this._populateReferrerFields();
    this.addEventListener("field-update", (event) => {
      this._storeFieldsToLocalStorage(
        event.detail.field,
        event.detail.changedProperties
      );
    });
    await this.updateComplete;
    this._lastUpdated = Date.now();
    window.parent.postMessage(`formLoaded_${this.formIdentifier}`);
  }
  refreshValues() {
    this._slottedChildren.forEach((elm) => {
      const el = elm;
      if (el.populateValue && el.populateValue()) {
        el.populateValue();
      }
    });
  }
  validate() {
    let isValid = true;
    this._slottedChildren.forEach((child) => {
      if (child.validate) {
        isValid = child.validate() && isValid;
      }
    });
    return isValid;
  }
  _clearStoredData() {
    localStorage.removeItem("savedFormData");
  }
  // Method to generate the form components according to the contentElements property and add them to the slot
  async _generateForm() {
    if (!this.contentElements || this.contentElements.length === 0) return;
    while (this.firstChild) {
      this.removeChild(this.firstChild);
    }
    const elements = await this.contentElements.reduce(
      async (prevPromise, element) => {
        const acc = await prevPromise;
        let elm;
        if (element.name === "formRow") {
          elm = document.createElement("div");
          elm.classList.add("combine");
          if (element.items) {
            const formElements = await element.items.reduce(
              async (itemsPromise, singleElement) => {
                const itemsAcc = await itemsPromise;
                const formElm = await this._makeFormElement(singleElement);
                if (formElm) {
                  itemsAcc.push(formElm);
                }
                return itemsAcc;
              },
              Promise.resolve([])
            );
            formElements.forEach((formElm) => elm.appendChild(formElm));
          }
        } else {
          elm = await this._makeFormElement(element);
        }
        if (elm) {
          acc.push(elm);
        }
        return acc;
      },
      Promise.resolve([])
    );
    elements.forEach((elm) => this.appendChild(elm));
    this.dispatchEvent(
      new CustomEvent("jb-form:ready", {
        bubbles: true,
        composed: true,
        detail: { formIdentifier: this.formIdentifier }
      })
    );
  }
  _getContentSpacingProperties() {
    if (this.bordered) {
      return { grid: true, colsMdUp: 8 };
    }
    return { grid: true, colsMdUp: 8, colsLgUp: 6 };
  }
  async _makeFormElement(componentProp) {
    const componentConstructor = {
      checkbox: JbCheckbox,
      infoBox: JbInfoBox,
      radio: JbRadio,
      richText: JbRichtext,
      select: JbSelect,
      submitButton: JbButtonPrimary,
      textArea: JbTextArea,
      textField: JbTextField,
      datePicker: void 0,
      multiCheckbox: void 0,
      timePicker: void 0,
      upload: void 0
    };
    const lazyLoadedComponents = ["datePicker", "multiCheckbox", "timePicker", "upload"];
    if (lazyLoadedComponents.includes(componentProp.name)) {
      switch (componentProp.name) {
        case "datePicker":
          {
            const { JbDatePicker } = await import("../components/jb-date-picker/jb-date-picker.js");
            componentConstructor.datePicker = JbDatePicker;
          }
          break;
        case "multiCheckbox":
          {
            const { JbMultiCheckbox } = await import("../components/jb-multi-checkbox/jb-multi-checkbox.js");
            componentConstructor.multiCheckbox = JbMultiCheckbox;
          }
          break;
        case "timePicker":
          {
            const { JbTimePicker } = await import("../components/jb-time-picker/jb-time-picker.js");
            componentConstructor.timePicker = JbTimePicker;
          }
          break;
        case "upload":
          {
            const { JbUpload } = await import("../components/jb-upload/jb-upload.js");
            componentConstructor.upload = JbUpload;
          }
          break;
        default:
          break;
      }
    }
    if (!(componentProp.name in componentConstructor)) return void 0;
    const ComponentClass = componentConstructor[componentProp.name];
    const componentInstance = new ComponentClass().init({
      props: componentProp.componentProperties,
      innerHTML: componentProp.innerHTML,
      childNodes: componentProp.childNodes,
      attributes: componentProp.attributes
    });
    return componentInstance;
  }
  _notifyCustomElements(e3) {
    this._slottedChildren.forEach((child) => {
      if (child.appendFormData) {
        child.appendFormData(e3);
      }
    });
  }
  _populateReferrerFields() {
    const params = new URLSearchParams(document.location.search.substring(1));
    if (this._referrerOriginalUrlField) {
      this._referrerOriginalUrlField.value = params.get("referrerOriginalUrl") || localStorage.getItem("page_url_english") || "";
    }
    if (this._referrerUrlField) {
      this._referrerUrlField.value = params.get("referrerUrl") || window.location.href;
    }
    if (this._referrerTitleField) {
      this._referrerTitleField.value = params.get("referrerTitle") || document.title;
    }
  }
  _renderHiddenFields() {
    if (this.additionalData === void 0 || Object.keys(this.additionalData).length === 0) {
      return A;
    }
    return Object.keys(this.additionalData).map(
      (key) => b`
        <input
          type="hidden"
          name="${key}"
          value="${this.additionalData ? this.additionalData[key] : ""}"
        />
      `
    );
  }
  _renderPhone(phoneString) {
    const phoneNumber = phoneString.match(/(?:[-+() ]*\d){10,13}/g);
    if (phoneNumber === null || phoneNumber[0] === null) return null;
    const anchor = document.createElement("a");
    const paragraph = document.createElement("p");
    anchor.innerText = phoneNumber[0].trim();
    setLink(anchor, { href: `tel:${phoneNumber[0].replace(/[^+1-9]/g, "")}` });
    paragraph.innerText = phoneString.replace(phoneNumber[0], "") + " ";
    paragraph.appendChild(anchor);
    return paragraph;
  }
  _renderValidationFields() {
    return b`
      <label
        class="internal"
        for="${this.validationFieldname}"
        >${this.validationFieldname}</label
      >
      <input
        type="text"
        name="${this.validationFieldname}"
        id="${this.validationFieldname}"
        class="internal"
        autocomplete="off"
        tabindex="-1"
        value=""
        maxlength="512"
      />
    `;
  }
  get _slottedChildren() {
    const returnArray = [];
    const slot = this.shadowRoot.querySelector("slot");
    slot.assignedElements({ flatten: true }).forEach((singleElement) => {
      if (singleElement.classList.contains("combine")) {
        singleElement.childNodes.forEach((child) => {
          returnArray.push(child);
        });
      } else {
        returnArray.push(singleElement);
      }
    });
    return returnArray;
  }
  _storeFieldsToLocalStorage(element, changedProperties) {
    if (changedProperties.has("value") && element.frontendRenderingIdentifier && typeof element.value === "string" && element.name.indexOf("checkbox") === -1) {
      let storedData = localStorage.getItem("savedFormData");
      if (storedData !== null) {
        storedData = JSON.parse(storedData);
      } else {
        storedData = {};
      }
      storedData[element.frontendRenderingIdentifier] = element.value;
      localStorage.setItem("savedFormData", JSON.stringify(storedData));
    }
  }
  _submit(e3) {
    const timeField = this.renderRoot.querySelector('input[name="form_analytics_time"]');
    const timeTaken = Date.now() - this._lastUpdated;
    if (timeField) {
      timeField.value = String(timeTaken);
    }
    if (e3.detail.name === "submit") {
      this._submitButton.click();
    }
  }
  _submitIfValid(e3) {
    const isValid = this.validate();
    if (!isValid) {
      e3.preventDefault();
      const invalidFields = this._slottedChildren.filter((child) => {
        const childAsFormElement = child;
        return childAsFormElement.validate && !childAsFormElement.validate();
      });
      if (invalidFields.length > 0) {
        const invalidField = invalidFields[0];
        let selectors = ["input:invalid", "input:not([aria-hidden])", "textarea"];
        if (["jb-select", "jb-radio"].includes(invalidField.tagName.toLowerCase())) {
          selectors = ['[tabindex="0"]'];
        }
        const selector = selectors.join(", ");
        const inputElement = invalidField.shadowRoot?.querySelector(selector) || invalidField.querySelector(selector);
        inputElement?.focus();
      }
    } else {
      this._submitButton.setAttribute("disabled", "disabled");
      this._clearStoredData();
      this.dispatchEvent(new CustomEvent("jb-form:submit", { detail: e3 }));
    }
  }
  render() {
    const sectionHeadline = this.sectionHeadline?.headline ? b`<jb-section-headline .headline=${this.sectionHeadline.headline}></jb-section-headline>` : A;
    const recipientBlock = this.generalConcern || this.recipient ? b`<div
            class="formheader"
            tabindex="-1"
          >
            <p class="general-concern">${this.generalConcern}</p>
            ${this.recipient ? b`<p class="recipient">${this.recipient}</p>` : A}
            ${this.recipientPosition ? b`<p>${this.recipientPosition}</p>` : A}
            ${this.recipientPhone ? this._renderPhone(this.recipientPhone) : A}
          </div>` : A;
    const formTitle = this.formHeader ? b`<jb-heading
          class="formtitle"
          offset=${this.sectionHeadline?.headline ? 1 : 0}
          tabindex="-1"
          variant="heading-md"
          >${this.formHeader}</jb-heading
        >` : A;
    return b`${sectionHeadline} ${recipientBlock} ${formTitle}
      <form
        @formdata=${this._notifyCustomElements}
        @submit=${this._submitIfValid}
        action=${this.action}
        class="${e2({ bordered: !!this.bordered })}"
        enctype="multipart/form-data"
        method="post"
      >
        ${this._renderHiddenFields()}
        <slot
          class="${e2({ grid: !!this.displayGrid, flex: !this.displayGrid })}"
          @jb-button:clicked=${this._submit}
        ></slot>
        ${this.validationFieldname ? this._renderValidationFields() : A}
        <input
          type="hidden"
          class="internal"
          name="form_analytics_time"
          id="form_analytics_time"
        />
        <button
          type="submit"
          class="hidden"
        ></button>
      </form>`;
  }
};
JbForm.styles = [reset_css_default, jb_form_css_default];
JbForm.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbForm.prototype, "action", 2);
__decorateClass([
  n({ type: Object })
], JbForm.prototype, "additionalData", 2);
__decorateClass([
  n({ type: Boolean })
], JbForm.prototype, "bordered", 2);
__decorateClass([
  n({ type: Array })
], JbForm.prototype, "contentElements", 2);
__decorateClass([
  n({ type: Boolean })
], JbForm.prototype, "displayGrid", 2);
__decorateClass([
  n()
], JbForm.prototype, "formHeader", 2);
__decorateClass([
  n()
], JbForm.prototype, "formIdentifier", 2);
__decorateClass([
  n()
], JbForm.prototype, "generalConcern", 2);
__decorateClass([
  n()
], JbForm.prototype, "multiformSubline", 2);
__decorateClass([
  n()
], JbForm.prototype, "recipient", 2);
__decorateClass([
  n()
], JbForm.prototype, "recipientPhone", 2);
__decorateClass([
  n()
], JbForm.prototype, "recipientPosition", 2);
__decorateClass([
  n({ type: Object })
], JbForm.prototype, "sectionHeadline", 2);
__decorateClass([
  n()
], JbForm.prototype, "trackingSubject", 2);
__decorateClass([
  n()
], JbForm.prototype, "validationFieldname", 2);
__decorateClass([
  e('input[name="tx_sitepackage[referrerOriginalUrl]"]')
], JbForm.prototype, "_referrerOriginalUrlField", 2);
__decorateClass([
  e('input[name="tx_sitepackage[referrerTitle]"]')
], JbForm.prototype, "_referrerTitleField", 2);
__decorateClass([
  e('input[name="tx_sitepackage[referrerUrl]"]')
], JbForm.prototype, "_referrerUrlField", 2);
__decorateClass([
  e('button[type="submit"].hidden')
], JbForm.prototype, "_submitButton", 2);
JbForm = __decorateClass([
  customElement("jb-form")
], JbForm);

export {
  JbForm
};
